<template>
  <div class="wallet">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買幫-我的錢包</a>
      </nav>
      <br />

      <div class="card">
        <div class="card-body">
          <h5>我的錢包餘額:</h5>
          <h4>${{ walletInfo.balance }}</h4>
          <br />
          <div class="alert alert-success" role="alert">
            <h4 class="alert-heading">代買幫錢包須知(試營運期間)</h4>
            <p>1.代買幫退款及補款金額紀錄於代買幫錢包內</p>
            <p>2.錢包內金額將於次筆付款時由系統計算一併扣除、加總</p>
            <p>3.結算錢包金額並退款至指定帳戶將扣除手續費新台幣15元</p>
            <hr />
            <h4 class="alert-heading">代買幫錢包扣抵方式</h4>
            <p>1.訂單金額與錢包餘額相同者將完全抵扣</p>
            <p>2.除(方式1)外,訂單金額抵扣後最少付款為新台幣100元</p>
            <p>3.未抵用完之金額將繼續保存於錢包至之後使用</p>
            <p>4.超過新台幣20000元之訂單或是商業報關用戶請另洽代買幫客服</p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
export default {
  name: 'wallet',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      checkUnChatbotSigninStatus: false,
      displayViews: '',
      walletInfo: {},
      series: [0],
      chartOptions: {
        plotOptions: {
          radialBar: {
            hollow: {
              size: '60%',
            },
          },
        },
        labels: ['累積金額'],
      },
    }
  },
  watch: {},
  methods: {
    checkUnChatbotSignin: function () {
      const vm = this
      if (!localStorage.userId) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '關閉',
            },
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })

        vm.checkUnChatbotSigninStatus = true
        return true
      } else {
        vm.userName = localStorage.userName
        vm.checkUnChatbotSigninStatus = false
        return false
      }
    },
    queryWalletByUserId: function (userId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
        }
        await axios
          .post(vm.apiUrl + 'QueryWalletByUserId', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(async function (response) {
            var data = response.data
            vm.walletInfo = data
            console.log('walletInfo:', vm.walletInfo)

            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '錢包查詢失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
  },
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    try {
      if (vm.$route.query.userId) {
        localStorage.userId = decodeURI(vm.$route.query.userId)
      }
      vm.checkUnChatbotSignin()
      vm.queryWalletByUserId(localStorage.userId)
    } catch (e) {
      // console.info(e);
      alert(e)
    }
  },
}
</script>
